var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMetrics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.26659 6.13203H4.39992C4.91325 6.13203 5.33325 6.55203 5.33325 7.06536V11.732C5.33325 12.2454 4.91325 12.6654 4.39992 12.6654H4.26659C3.75325 12.6654 3.33325 12.2454 3.33325 11.732V7.06536C3.33325 6.55203 3.75325 6.13203 4.26659 6.13203ZM7.99992 3.33203C8.51325 3.33203 8.93325 3.75203 8.93325 4.26536V11.732C8.93325 12.2454 8.51325 12.6654 7.99992 12.6654C7.48659 12.6654 7.06659 12.2454 7.06659 11.732V4.26536C7.06659 3.75203 7.48659 3.33203 7.99992 3.33203ZM11.7333 8.66537C12.2466 8.66537 12.6666 9.08537 12.6666 9.5987V11.732C12.6666 12.2454 12.2466 12.6654 11.7333 12.6654C11.2199 12.6654 10.7999 12.2454 10.7999 11.732V9.5987C10.7999 9.08537 11.2199 8.66537 11.7333 8.66537Z",
    fill: "#3A6085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetrics);
export default __webpack_public_path__ + "static/media/metrics.7db9d1c884fd9d3f26e44169f032426b.svg";
export { ForwardRef as ReactComponent };